import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { HttpClientModule } from "@angular/common/http";
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

import { UserRoutingModule } from './user-routing.module';
import { UserComponent } from './user.component';
import { UserLoginComponent } from './componentes/formulario/user-login/user-login.component';
import { UserRegistroComponent } from './componentes/formulario/user-registro/user-registro.component';
import { ContenedorRegLogComponent } from './componentes/custom/contenedor-reg-log/contenedor-reg-log.component';
import { ContendorComponent } from './componentes/custom/contendor/contendor.component';
import { PagoSuccessComponent } from './componentes/custom/pago-success/pago-success.component';


@NgModule({
   declarations: [
      UserComponent,
      UserLoginComponent,
      UserRegistroComponent,
      ContenedorRegLogComponent,
      ContendorComponent,
      PagoSuccessComponent,

   ],
   imports: [
      HttpClientModule,
      BrowserModule,
      BrowserAnimationsModule,
      SharedModule,
      UserRoutingModule,
      FormsModule,
   ],
   exports: [
      UserLoginComponent,
      UserRegistroComponent,
      ContenedorRegLogComponent,
      PagoSuccessComponent,
      ContendorComponent

   ],
   providers: [],
   schemas: [
      CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA
   ],
})
export class UserModule { }